/**
 * Created by Josef Jurca on 8.3.2017.
 */

import {getInstance as getDataSources} from 'datasources';

// Action types
const ActionTypes = {
        SET_ASSET: 'SET_ASSET'
    },

    // Status values
    AssetStatuses = {
        UNPREPARED: 'unprepared',
        PREPARED: 'prepared'
    };

/**
 * Creates and returns a set asset action.
 *
 * @param {Asset} asset - Asset.
 * @returns {Object} Set asset action.
 */
function setAsset (asset) {
    return {
        type: ActionTypes.SET_ASSET,
        asset
    };
}

/**
 * Creates and returns a get asset action.
 *
 * @param {number} assetId - Asset id.
 * @param {string} query - Asset query.
 * @returns {Function} Dispatch function.
 */
function getAssetById (assetId, query) {
    let dataSources = getDataSources();

    return (dispatch) => {
        return dataSources.getAsset(assetId, query)
            .then((asset) => {
                dispatch(setAsset(asset));
            });
    };
}

export {
    ActionTypes,
    AssetStatuses,
    setAsset,
    getAssetById
};


// WEBPACK FOOTER //
// ./src/js/store/actions/asset.js